import React from "react";
import { GroupCardsButton } from "../styles";
import { useTranslation } from "react-i18next";
import { useOpticsStore } from "../../../../stores/use-optics-store";
import { macroStores } from "../../../../stores/export-stores";
import { MACRO_KEY } from "../../../defaults";
import { CARDS_PROP } from "../../drawers/settings/features/cards/defaults";
import { DEFAULT_TAB } from "../../../../features/cards-v2/components/tabs/defaults";

const typeLabels = {
  [MACRO_KEY.CARDS]: "cards",
  [MACRO_KEY.NEWS]: "news",
  [MACRO_KEY.PAGES]: "pages",
  [MACRO_KEY.PEOPLE]: "people",
  [MACRO_KEY.SPACES]: "spaces",
};

const GroupCards = () => {
  const macro = useOpticsStore((state) => state.macro);
  const state = macroStores[macro]?.();
  const { t } = useTranslation();

  if (!state) return <></>;

  const data = state.data;
  const config = Array.isArray(data) ? data[0]?.config : data?.config;
  if (!config) return <></>;

  const showTabs = config.hasTabs ?? config.showTabs;

  const label = showTabs ? "ungroup-in-tabs" : "group-in-tabs";

  const toggleTabs = () => {
    if (macro === MACRO_KEY.CARDS) {
      state.updateCardsConfig?.({
        key: CARDS_PROP.HAS_TABS,
        value: !config.hasTabs,
      });

      const tabs = data?.[0]?.tabs ?? [];

      if (!tabs.length) {
        state.updateCardsTabs?.([DEFAULT_TAB]);
        state.updateCardsData?.({
          key: CARDS_PROP.TAB_ID,
          value: DEFAULT_TAB.id,
        });
        state.setCardsTab?.(DEFAULT_TAB);
      }
    } else {
      state.updateConfig?.({ value: { showTabs: !config.showTabs } });
    }
  };

  return (
    <GroupCardsButton onClick={toggleTabs}>
      {t(label, { macro: typeLabels[macro] || "items" })}
    </GroupCardsButton>
  );
};

export default GroupCards;
